import "./StatusBadge.css";

const SHAPE = {
  scheduled: <span className="booth-badge-dot booth-badge-dot--hollow" aria-hidden="true" />,
  onair: <span className="booth-badge-dot booth-badge-dot--onair" aria-hidden="true" />,
  final: <span className="booth-badge-dot booth-badge-dot--final" aria-hidden="true" />,
  filed: <span className="booth-badge-square booth-badge-square--filed" aria-hidden="true" />,
  corrected: <span className="booth-badge-square booth-badge-square--corrected" aria-hidden="true" />,
};

const LABEL = {
  scheduled: "Scheduled",
  onair: "On air",
  final: "Final",
  filed: "Filed",
  corrected: "Corrected",
};

/** One live-object status: scheduled, onair, final, filed, corrected. */
function StatusBadge({ state, detail, className = "" }) {
  return (
    <span className={`booth-badge booth-badge--${state} ${className}`.trim()}>
      {SHAPE[state]}
      <span className="booth-badge-label">{LABEL[state]}</span>
      {detail && <span className="booth-badge-detail">{detail}</span>}
    </span>
  );
}

export default StatusBadge;
